<template>
    <div style="min-height: 400px;">
        <gcmcn-filters
            ref="gcmcn-filters"
            style="margin-top: 18px;"
            :filter-values="[selectedSortType, searchFilter, selectedTakersForFilter, selectedEntitiesForFilter]"
            @reset-filters="resetFilters"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="Takers"
                :multiple="true"
                :list="$store.getters.takers"
                itemName="name"
                itemValue="uid"
                :itemsSelected="selectedTakersForFilter"
                @on-select-item="onSelectTakers"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="$store.getters.entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <dropdown
                name="Receiver type"
                :multiple="true"
                :list="typeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedTypes.length > 0 ? selectedTypes : []"
                @on-select-item="setSelectedTypes"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div v-if="filteredManualReceivers.length > 0" style="overflow-y: scroll;" :style="{maxHeight: `calc(100vh - ${usedHeight}px)`}">
            <manual-receiver-card
                v-for="mr in filteredManualReceivers"
                :key="mr.uid"
                :manual-receiver="mr"
                :selected-manual-receiver-uid="selectedManualReceiverUid"
                @change-selected-manual-receiver="changeSelectedManualReceiver"
            >
            </manual-receiver-card>
        </div>
        <div v-else-if="$store.getters.manualReceivers.length > 0" class="list-empty">
            No manual receiver(s) match this filters.
        </div>
        <div v-else class="list-empty">
            No manual receiver(s).
        </div>
    </div>
</template>

<script>

import ManualReceiverCard from './manualReceiverCard.vue';
import { mapGetters } from 'vuex';
import {
    GcmcnFilters,
    Dropdown,
    SearchFilter
} from 'gcmcn-common';
export default {

    components: {
        ManualReceiverCard,
        GcmcnFilters,
        Dropdown,
        SearchFilter,
    },
    props: {

    },

    data (){
        return {
            selectedSortType: 'asc',
            searchFilter: '',
            selectedManualReceiverUid: '',
            usedHeight: 0,
            selectedTypes: [],
        };
    },

    computed: {
        ...mapGetters([
            'windowWidth',
            'selectedTakersForFilter',
            'selectedEntitiesForFilter',
            'manualReceivers',
        ]),
        typeList(){
            let types = this.manualReceivers.map(receiver => receiver.source_protocol_type);
            let uniqueTypes = [...new Set(types)];
            return uniqueTypes.map(type => {
                return {
                    name: type.toUpperCase(),
                    value: type,
                };
            });
        },
        filteredManualReceivers (){
            let mr = this.manualReceivers.slice();
            if(this.selectedSortType){
                mr.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    mr.reverse();
                }
            }
            if(this.selectedEntitiesForFilter.length > 0){
                mr = mr.filter((ird) => {
                    let taker = this.$store.getters.takersByUid(ird.taker_uid);
                    return taker ? this.selectedEntitiesForFilter.includes(taker.scopes.entity_uid) : false;
                });
            }
            if(this.selectedTakersForFilter.length > 0){
                mr = mr.filter((ird) => this.selectedTakersForFilter.includes(ird.taker_uid));
            }
            if(this.selectedTypes.length > 0){
                mr = mr.filter(receiver => this.selectedTypes.includes(receiver.source_protocol_type));
            }
            if(this.searchFilter){
                mr = mr.filter((ird) => ird.remote_id.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return mr;
        },
    },
    watch: {
        windowWidth() {
            this.computeFilterHeight();
        }
    },
    mounted (){
        this.computeFilterHeight();
    },

    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32;
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },

        resetFilters (){
            this.selectedSortType = '';
            this.selectedTypes = [];
            this.$refs.search.clear();
            this.$store.commit('CLEAR_ALL_FILTERS');
        },

        changeSelectedManualReceiver (irdUid){
            this.selectedManualReceiverUid = irdUid;
            this.$emit('change-selected-manual-receiver', irdUid);
        },
        onSelectEntity (entities){
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
        onSelectTakers (takers){
            this.$store.commit('SET_TAKERS_FOR_FILTER', takers);
        },
        setSelectedTypes(types){
            this.selectedTypes = types;
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/Manual/manualReceiverList.vue